<div class="card grid {{ class }}">
  <div class="d-none d-lg-block d-xl-block">
    <table class="table desktop">
      <tr>
        <td class="br">
          <div class="label">
            {{ uppercase ? ("Profit" | uppercase) : "Profit" }}
          </div>
          <div
            class="value fs-24"
            [ngClass]="{
              'text-red': data.profit < 0,
              'text-yellow': data.profit === 0,
              'text-green': data.profit > 0
            }"
          >
            <span
              labelNumber="{{ data.profit }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </div>
          <table class="table">
            <tr>
              <td width="200">
                {{ uppercase ? ("Customer:" | uppercase) : "Customer:" }}
              </td>
              <td>
                <span
                  class="text-{{
                    data.customer > 0
                      ? 'green'
                      : data.customer < 0
                      ? 'red'
                      : 'yellow'
                  }}"
                >
                  <span
                    labelNumber="{{ data.customer }}"
                    [currency]="currency"
                    [emo]="'1'"
                  ></span>
                </span>
              </td>
            </tr>
            <tr>
              <td width="200">
                {{ uppercase ? ("Commission:" | uppercase) : "Commission:" }}
              </td>
              <td>
                <span
                  class="text-{{
                    data.commission > 0
                      ? 'green'
                      : data.commission < 0
                      ? 'red'
                      : 'yellow'
                  }}"
                >
                  <span
                    labelNumber="{{ data.commission }}"
                    [currency]="currency"
                    [emo]="'1'"
                  ></span>
                </span>
              </td>
            </tr>
            <tr>
              <td width="200">
                {{ uppercase ? ("Swap:" | uppercase) : "Swap:" }}
              </td>
              <td>
                <span
                  class="text-{{
                    data.swap > 0 ? 'green' : data.swap < 0 ? 'red' : 'yellow'
                  }}"
                >
                  <span
                    labelNumber="{{ data.swap }}"
                    [currency]="currency"
                    [emo]="'1'"
                  ></span>
                </span>
              </td>
            </tr>
          </table>
        </td>
        <td class="br">
          <div class="label">
            {{ uppercase ? ("Fees & Payout" | uppercase) : "Profit" }}
          </div>
          <div
            class="value fs-24 text-{{
              data.feePayout > 0
                ? 'green'
                : data.feePayout < 0
                ? 'red'
                : 'yellow'
            }}"
          >
            <span
              labelNumber="{{ data.feePayout }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </div>
          <table class="table">
            <tr>
              <td width="200">
                {{ uppercase ? ("IB Payout:" | uppercase) : "IB Payout:" }}
              </td>
              <td>
                <span
                  class="text-{{
                    data.ib > 0 ? 'green' : data.ib < 0 ? 'red' : 'yellow'
                  }}"
                >
                  <span
                    labelNumber="{{ data.ib }}"
                    [currency]="currency"
                    [emo]="'1'"
                  ></span>
                </span>
              </td>
            </tr>
            <tr>
              <td width="200">
                {{ uppercase ? ("Bonus:" | uppercase) : "Bonus:" }}
              </td>
              <td>
                <span
                  class="text-{{
                    data.bonus > 0 ? 'green' : data.bonus < 0 ? 'red' : 'yellow'
                  }}"
                >
                  <span
                    labelNumber="{{ data.bonus }}"
                    [currency]="currency"
                    [emo]="'1'"
                  ></span>
                </span>
              </td>
            </tr>
            <tr>
              <td width="200">
                {{
                  uppercase
                    ? ("Withdrawal:" | uppercase)
                    : "Withdrawal:"
                }}
              </td>
              <td>
                <span
                  class="text-{{
                    data.wallet > 0
                      ? 'green'
                      : data.wallet < 0
                      ? 'red'
                      : 'yellow'
                  }}"
                >
                  <span
                    labelNumber="{{ data.wallet }}"
                    [currency]="currency"
                    [emo]="'1'"
                  ></span>
                </span>
              </td>
            </tr>
          </table>
        </td>
        <td>
          <div class="label">
            {{ uppercase ? ("NET PROFIT" | uppercase) : "NET PROFIT" }}
          </div>
          <div *ngIf="timeago">
            <small class="text-muted"
              ><i>{{
                "(Data retrieved " + timeago + " minutes ago)"
              }}</i></small
            >
          </div>
          <div
            class="value fs-24 text-{{
              data.netProfit > 0
                ? 'green'
                : data.netProfit < 0
                ? 'red'
                : 'yellow'
            }}"
          >
            <span
              labelNumber="{{ data.netProfit }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <div class="d-block d-lg-none d-xl-none">
    <table class="table mobile">
      <tr>
        <td>
          {{ uppercase ? ("Profit:" | uppercase) : "Profit:" }}
        </td>
        <td>
          <span
            class="fs-24 text-{{
              data.profit > 0 ? 'green' : data.profit < 0 ? 'red' : 'yellow'
            }}"
          >
            <span
              labelNumber="{{ data.profit }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </span>
        </td>
      </tr>
      <tr>
        <td>
          {{ uppercase ? ("Customer:" | uppercase) : "Customer:" }}
        </td>
        <td>
          <span
            class="text-{{
              data.customer > 0 ? 'green' : data.customer < 0 ? 'red' : 'yellow'
            }}"
          >
            <span
              labelNumber="{{ data.customer }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </span>
        </td>
      </tr>
      <tr>
        <td>
          {{ uppercase ? ("Commission:" | uppercase) : "Commission:" }}
        </td>
        <td>
          <span
            class="text-{{
              data.commission > 0
                ? 'green'
                : data.commission < 0
                ? 'red'
                : 'yellow'
            }}"
          >
            <span
              labelNumber="{{ data.commission }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </span>
        </td>
      </tr>
      <tr>
        <td>
          {{ uppercase ? ("Swap:" | uppercase) : "Swap:" }}
        </td>
        <td>
          <span
            class="text-{{
              data.swap > 0 ? 'green' : data.swap < 0 ? 'red' : 'yellow'
            }}"
          >
            <span
              labelNumber="{{ data.swap }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </span>
        </td>
      </tr>
      <tr>
        <td>
          {{ uppercase ? ("Fee & Payout:" | uppercase) : "Fee & Payout:" }}
        </td>
        <td>
          <span
            class="fs-24 text-{{
              data.feePayout > 0
                ? 'green'
                : data.feePayout < 0
                ? 'red'
                : 'yellow'
            }}"
          >
            <span
              labelNumber="{{ data.feePayout }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </span>
        </td>
      </tr>
      <tr>
        <td>
          {{ uppercase ? ("IB Payout:" | uppercase) : "IB Payout:" }}
        </td>
        <td>
          <span
            class="text-{{
              data.ib > 0 ? 'green' : data.ib < 0 ? 'red' : 'yellow'
            }}"
          >
            <span
              labelNumber="{{ data.ib }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </span>
        </td>
      </tr>
      <tr>
        <td class="bb">
          {{
            uppercase ? ("Withdrawal Fees:" | uppercase) : "Withdrawal Fees:"
          }}
        </td>
        <td class="bb">
          <span
            class="text-{{
              data.wallet > 0 ? 'green' : data.wallet < 0 ? 'red' : 'yellow'
            }}"
          >
            <span
              labelNumber="{{ data.wallet }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </span>
        </td>
      </tr>
      <tr>
        <td>
          {{ uppercase ? ("NET PROFIT:" | uppercase) : "NET PROFIT:" }}
          <div *ngIf="timeago">
            <small class="text-muted"
              ><i>{{
                "(Data retrieved " + timeago + " minutes ago)"
              }}</i></small
            >
          </div>
        </td>
        <td>
          <span
            class="value fs-24 text-{{
              data.netProfit > 0
                ? 'green'
                : data.netProfit < 0
                ? 'red'
                : 'yellow'
            }}"
          >
            <span
              labelNumber="{{ data.netProfit }}"
              [currency]="currency"
              [emo]="'1'"
            ></span>
          </span>
        </td>
      </tr>
    </table>
  </div>
</div>
